// extracted by mini-css-extract-plugin
export default {"spinner":"I3H-","rotator":"_2gAa","path":"e11w","dash":"Z0k-"};